"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlarmingWrapChartsInject = void 0;
var _paulCorePackage = require("paul-core-package");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("../../../utils/constants");
var _reducers = require("../../../redux/reducers");
var _sagas = _interopRequireDefault(require("../../../redux/sagas"));
var _AlarmingChartsConnect = require("./AlarmingChartsConnect");
var _ChartParams = require("../../../features/provider/ChartParams");
const _excluded = ["isDynamicHeight"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const AlarmingWrapChartsInject = _ref => {
  let {
      isDynamicHeight
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  (0, _paulCorePackage.useInjectStore)({
    key: _constants.packageKey,
    reducer: {
      charts: _reducers.charts,
      devices: _reducers.devices
    },
    saga: _sagas.default
  });
  return /*#__PURE__*/_react.default.createElement(_ChartParams.ChartParamsProvider, {
    isDynamicHeight: isDynamicHeight
  }, /*#__PURE__*/_react.default.createElement(_AlarmingChartsConnect.AlarmingChartsConnect, props));
};
exports.AlarmingWrapChartsInject = AlarmingWrapChartsInject;
AlarmingWrapChartsInject.propTypes = {
  isDynamicHeight: _propTypes.default.bool
};